import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { mockBooks } from '../services/dataService';
import { getBookImage } from '../utils/imageUtils';

/**
 * Marketplace Page Component
 * Book categories, list, and cart
 */
const Marketplace = () => {
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [cart, setCart] = useState([]);

  const categories = ['All', 'Rocket Science', 'Astronomy', 'Engineering', 'Exploration'];

  const filteredBooks = selectedCategory === 'All' 
    ? mockBooks 
    : mockBooks.filter(book => book.category === selectedCategory);

  const addToCart = (book) => {
    setCart([...cart, book]);
    alert(`${book.title} added to cart!`);
  };

  const cartCount = cart.length;
  const cartTotal = cart.reduce((sum, book) => sum + book.price, 0);

  return (
    <div className="container" style={{ paddingTop: '30px' }}>
      <h1 style={{ fontSize: '36px', marginBottom: '30px', textAlign: 'center' }}>
        📚 Marketplace
      </h1>

      {/* Cart Summary */}
      {cartCount > 0 && (
        <div className="card" style={{ 
          marginBottom: '30px', 
          background: 'var(--highlight-color)',
          textAlign: 'center'
        }}>
          <h3 style={{ marginBottom: '10px' }}>Cart ({cartCount} items)</h3>
          <p style={{ marginBottom: '10px' }}>Total: ${cartTotal.toFixed(2)}</p>
          <button className="btn btn-secondary" onClick={() => alert('Checkout feature - Demo mode')}>
            Checkout
          </button>
        </div>
      )}

      {/* Category Filter */}
      <div style={{ 
        display: 'flex', 
        gap: '10px', 
        justifyContent: 'center', 
        marginBottom: '30px',
        flexWrap: 'wrap'
      }}>
        {categories.map(category => (
          <button
            key={category}
            onClick={() => setSelectedCategory(category)}
            className={selectedCategory === category ? 'btn btn-primary' : 'btn btn-secondary'}
          >
            {category}
          </button>
        ))}
      </div>

      {/* Books Grid */}
      <div className="grid">
        {filteredBooks.map(book => (
          <div key={book.id} className="card">
            <img 
              src={getBookImage(book.id, book.title)} 
              alt={book.title}
              style={{ 
                width: '100%', 
                height: '300px', 
                objectFit: 'cover', 
                borderRadius: '8px', 
                marginBottom: '15px' 
              }}
              onError={(e) => {
                e.target.style.display = 'none';
              }}
            />
            <h2 style={{ color: 'var(--highlight-color)', marginBottom: '15px' }}>
              {book.title}
            </h2>
            <p style={{ marginBottom: '10px' }}>
              <strong>Author:</strong> {book.author}
            </p>
            <p style={{ marginBottom: '10px' }}>
              <strong>Category:</strong> {book.category}
            </p>
            <p style={{ marginBottom: '10px' }}>
              <strong>Rating:</strong> ⭐ {book.rating}/5.0
            </p>
            <p style={{ marginBottom: '15px', color: 'var(--text-dark)' }}>
              {book.description}
            </p>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div style={{ fontSize: '24px', color: 'var(--highlight-color)', fontWeight: 'bold' }}>
                ${book.price.toFixed(2)}
              </div>
              <button onClick={() => addToCart(book)} className="btn btn-primary">
                Add to Cart
              </button>
            </div>
            <Link to={`/marketplace/${book.id}`} className="btn btn-secondary" style={{ marginTop: '15px', display: 'block', textAlign: 'center' }}>
              View Details
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Marketplace;
